import { calculateIso8601DurationFromTimePeriod, TimePeriod } from "@src/cloud-connect/utils/calculate-iso-8601-duration-from-time-period";

interface BuildRequestedDurationParams {
  timeDuration: string;
  timePeriod: string;
}
export const buildRequestedDuration = (
  {timeDuration, timePeriod}: BuildRequestedDurationParams,
): string | undefined => {
  if (!timeDuration || !timePeriod) {
    return undefined;
  }

  const convertTimePeriod: TimePeriod = {
    amount: Number(timeDuration),
    time_unit: timePeriod as TimePeriod["time_unit"],
  };

  return calculateIso8601DurationFromTimePeriod(convertTimePeriod);
};
